// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"quote-with-cta_wrapper__Ad6lL","cta":"quote-with-cta_cta__q56Ur"};